export const valueDiscontCredicard = (previewData,discont) => {
    if (!previewData) {
        return "R$ 0,00";
    }

    const formatNumber = (valorString) => {
        if (!valorString) return 0;
        const numberValue = Number(valorString.replace(/[^\d,-]/g, '').replace(',', '.'));
        return isNaN(numberValue) ? 0 : numberValue;
    };
    const formatCurrency = (numberValue) => {
        return numberValue?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    if (previewData.aditionalValue) {
        if (discont) {

            const value = formatNumber(previewData?.value);
            const additionalValue = formatNumber(previewData?.aditionalValue);
            const originalDiscount = formatNumber(discont);
            const desconto = (originalDiscount / 100) * value;
            const ValueAfterDescont = value - desconto;
            const finalValueAfterDiscount = formatCurrency(ValueAfterDescont + additionalValue);
            return finalValueAfterDiscount;
        } else {
            const valueTotal = formatNumber(previewData?.value) + formatNumber(previewData?.aditionalValue)
            return formatCurrency(Number(valueTotal))
        }
    } else {
        if (discont) {

            const value = formatNumber(previewData?.value);
            const originalDiscount = formatNumber(discont);
            const desconto = (originalDiscount / 100) * value;
            const finalValue = value - desconto;
            const finalValueAfterDiscount = formatCurrency(finalValue);
            return finalValueAfterDiscount;
        } else {

            return `${previewData.value || 0}`
        }
    }
}
